import { useState } from "react";
import { api } from "@/api";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";

const inputCls = "mt-2 w-full border-b border-bark/40 bg-transparent py-2.5 outline-none transition-[border-color] duration-300 focus:border-clay";

const formatError = (detail) => {
  if (!detail) return "Erreur. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

const AdminPassword = () => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("La confirmation ne correspond pas au nouveau mot de passe");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Mot de passe modifié", { description: "Il est actif immédiatement pour vos prochaines connexions." });
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="max-w-2xl space-y-6 border-t border-ink/10 pt-10" data-testid="admin-password-form">
      <h2 className="flex items-center gap-3 font-serif text-2xl tracking-tight">
        <KeyRound size={20} className="text-clay" /> Changer mon mot de passe
      </h2>
      <div className="grid gap-6 sm:grid-cols-3">
        <div>
          <label className="text-xs uppercase tracking-[0.25em] text-taupe">Actuel</label>
          <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} data-testid="password-input-current" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.25em] text-taupe">Nouveau (8 caractères min.)</label>
          <input type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} data-testid="password-input-new" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.25em] text-taupe">Confirmation</label>
          <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} data-testid="password-input-confirm" />
        </div>
      </div>
      <button type="submit" disabled={busy} data-testid="password-save" className="flex items-center gap-3 rounded-full bg-ink px-8 py-3.5 text-sm font-medium text-cream transition-colors duration-300 hover:bg-clay disabled:opacity-60">
        {busy && <Loader2 size={15} className="animate-spin" />}
        Modifier mon mot de passe
      </button>
    </form>
  );
};

export default AdminPassword;
